export default {
  namespaced: true,
  state: {
    selected_menu: 0,
    options: {
      company_id: null,
      region_id: null,
      store_id: null
    },
    list: [
      /*{ title: "Users", icon: "/img/users.png", link: "/admin/users" },*/
      {
        title: "Report",
        icon: require("@/assets/img/icons/report.svg"),
        link: "/admin/reports",
        type: "analyze"
      },
     /*  {
        title: "Insights",
        icon: require("@/assets/img/icons/insignts.svg"),
        link: "/admin/insights",
        type: "analyze"
      }, */
      {
        title: "Sales",
        icon: require("@/assets/img/icons/insignts.svg"),
        link: "/admin/sales",
        type: "analyze"
      },
      {
        title: "Company",
        icon: require("@/assets/img/icons/insignts.svg"),
        link: "/admin/companies",
        type: "manage"
      },
      {
        title: "Guards",
        icon: require("@/assets/img/icons/guards.svg"),
        link: "/admin/guards",
        type: "manage"
      },
      {
        title: "Coupons",
        icon: require("@/assets/img/icons/coupons.svg"),
        link: "/admin/coupons",
        type: "manage"
      },

      {
        title: "Settings",
        icon: require("@/assets/img/icons/setting.svg"),
        link: "/admin/settings",
        type: "manage"
      },
      {
        title: "Enterprises",
        icon: "/img/faqs.png",
        link: "/admin/enterprises"
      },
      { title: "Notifications",
        icon: require("@/assets/img/faqs.png"),
        link: "/admin/user_push_notifications",
        type: "manage"
      },
      { title: "Faqs",
        icon: require("@/assets/img/faqs.png"),
        link: "/admin/faqs",
        type: "manage"
      },
      { title: "Update Password",
        icon: require("@/assets/img/faqs.png"),
        link: "/admin/update-password",
        type: "manage"
      },
    ],
    list_analyze: []
  },
  mutations: {
    set_selected_menu(state, selected) {
      state.selected_menu = selected;
    },
    add_items(state, data) {
      if (data.company_id) state.options.company_id = data.company_id;
      if (data.region_id){
        state.options.region_id = data.region_id;
        state.options.store_id = null;
      } 
      if (data.store_id) state.options.store_id = data.store_id;
    }
  },
  actions: {
    selected_menu({ commit }, selected) {
      commit("set_selected_menu", selected);
    },
    selectItem({ commit }, item) {
      commit("add_items", item);
    }
  },
  getters: {},
  setters: {},
  modules: {}
};
